"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.init = init;
exports.pushFeedbackMessage = pushFeedbackMessage;
exports.pushLikeMessage = pushLikeMessage;
exports.resetVotingResults = resetVotingResults;
exports.resetAnswers = resetAnswers;

var _promise = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/promise"));

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _config = _interopRequireDefault(require("../../../../targets/cord_eurofh_teams/config.js"));

var _BuildConstants = require("../../../utils/BuildConstants");

var _reflux = _interopRequireDefault(require("reflux"));

var _FeedbackSendActions = _interopRequireDefault(require("./Stores/FeedbackSendActions2"));

var _RegisterInstance = _interopRequireDefault(require("../RegisterInstance"));

var _FeedbackReceiveActions = _interopRequireDefault(require("./Stores/FeedbackReceiveActions2"));

var _GetFullFeedbacks = _interopRequireDefault(require("./Services/GetFullFeedbacks"));

var _MessagingService = _interopRequireDefault(require("../MessagingService"));

var _KESI2Helper = _interopRequireDefault(require("../../KESI2Helper"));

var _ResumeSuspendListeners = require("../../../helpers/ResumeSuspendListeners");

var _GetFullLikes = _interopRequireDefault(require("./Services/GetFullLikes"));

var _DeviceInfoHelper = _interopRequireDefault(require("../../../helpers/DeviceInfoHelper"));

var _TimeoutHelper = require("../../../helpers/TimeoutHelper");

/**
 * Created by falknisius on 16.06.17.
 */
var FEEDBACK_CHANNEL = "".concat(_BuildConstants.ABLY_CHANNEL_PREFIX, "SHORT_FEEDBACK");

function innerInit() {
  // in case it was added before
  _DeviceInfoHelper["default"].removeOnlineListener(innerInit);

  _MessagingService["default"].registerConnect(function () {
    console.log("channel ".concat(FEEDBACK_CHANNEL, " connected"));
  });

  if (_config["default"].hasLikeFunctionalityForLectures || _config["default"].hasLikeFunctionalityForNuggets) {
    readFullLikesAndFeedbacksAndListenAfterSuccess();
  } else {
    readFullFeedbacksAndListenAfterSuccess();
  }
}

function init() {
  return _init.apply(this, arguments);
}
/**
 *
 * @param questionId  - the id of the question
 * @param answerIds   - the array of ids from clicked answers (in multiple choice), the id of the clicked answer in single choice
 *
 * build a message enhanced with the applicationInstanceId, and localTimestamp
 * store it async in a local persistent queue
 */


function _init() {
  _init = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3() {
    var online;
    return _regenerator["default"].wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            console.log('init feedback service'); // ensure instance id is generated

            _context3.next = 3;
            return _RegisterInstance["default"].init();

          case 3:
            online = _DeviceInfoHelper["default"].isOnline();

            if (online) {
              _context3.next = 7;
              break;
            }

            _DeviceInfoHelper["default"].addOnlineListener(innerInit());

            return _context3.abrupt("return");

          case 7:
            innerInit();

          case 8:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _init.apply(this, arguments);
}

function pushFeedbackMessage(_x, _x2) {
  return _pushFeedbackMessage.apply(this, arguments);
}

function _pushFeedbackMessage() {
  _pushFeedbackMessage = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4(questionId, answerIds) {
    var message;
    return _regenerator["default"].wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            console.log('pushFeedbackMessage', questionId, answerIds);

            if (!(typeof answerIds === 'undefined')) {
              _context4.next = 4;
              break;
            }

            console.error('no answers');
            return _context4.abrupt("return");

          case 4:
            if (!(answerIds === null)) {
              _context4.next = 7;
              break;
            }

            console.error('no answers');
            return _context4.abrupt("return");

          case 7:
            if (typeof answerIds === 'string') {
              answerIds = [answerIds];
            }

            if (answerIds instanceof Array) {
              _context4.next = 11;
              break;
            }

            console.error('no answers');
            return _context4.abrupt("return");

          case 11:
            answerIds.forEach(function (answer, index) {
              if (!answer.indexOf(questionId + '_') === 0) {
                answerIds[index] = questionId + '_' + answer;
              }
            });
            console.log('pushFeedbackMessage2', questionId, answerIds);
            _context4.t0 = questionId;
            _context4.t1 = answerIds;
            _context4.t2 = new Date().getTime();
            _context4.next = 18;
            return _RegisterInstance["default"].getApplicationInstanceId();

          case 18:
            _context4.t3 = _context4.sent;
            message = {
              questionId: _context4.t0,
              answerIds: _context4.t1,
              deviceUTCTime: _context4.t2,
              applicationInstanceId: _context4.t3
            };

            _FeedbackSendActions["default"].feedbackMessageEnqueueAction(message);

          case 21:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _pushFeedbackMessage.apply(this, arguments);
}

function pushLikeMessage(_x3, _x4, _x5) {
  return _pushLikeMessage.apply(this, arguments);
}

function _pushLikeMessage() {
  _pushLikeMessage = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee5(nuggetId, action, rootId) {
    var message;
    return _regenerator["default"].wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            if (!(typeof nuggetId === 'undefined')) {
              _context5.next = 3;
              break;
            }

            console.error('no like-id');
            return _context5.abrupt("return");

          case 3:
            if (!(nuggetId === null)) {
              _context5.next = 6;
              break;
            }

            console.error('no like-id');
            return _context5.abrupt("return");

          case 6:
            _context5.t0 = rootId;
            _context5.t1 = nuggetId;
            _context5.t2 = action;
            _context5.t3 = new Date().getTime();
            _context5.next = 12;
            return _RegisterInstance["default"].getApplicationInstanceId();

          case 12:
            _context5.t4 = _context5.sent;
            message = {
              rootId: _context5.t0,
              likeId: _context5.t1,
              action: _context5.t2,
              deviceUTCTime: _context5.t3,
              applicationInstanceId: _context5.t4
            };
            console.log('send like message', message);

            _FeedbackSendActions["default"].feedbackMessageEnqueueAction(message);

          case 16:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));
  return _pushLikeMessage.apply(this, arguments);
}

function resetVotingResults() {
  return _resetVotingResults.apply(this, arguments);
}

function _resetVotingResults() {
  _resetVotingResults = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee6() {
    var promises;
    return _regenerator["default"].wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            promises = _KESI2Helper["default"].getVoteNuggetIds().map(function (id) {
              return resetAnswers(id);
            });
            _context6.next = 3;
            return _promise["default"].all(promises);

          case 3:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));
  return _resetVotingResults.apply(this, arguments);
}

function resetAnswers(_x6) {
  return _resetAnswers.apply(this, arguments);
}

function _resetAnswers() {
  _resetAnswers = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee7(questionId) {
    var message, channel;
    return _regenerator["default"].wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            _context7.t0 = questionId;
            _context7.t1 = new Date().getTime();
            _context7.next = 4;
            return _RegisterInstance["default"].getApplicationInstanceId();

          case 4:
            _context7.t2 = _context7.sent;
            message = {
              questionId: _context7.t0,
              deviceUTCTime: _context7.t1,
              applicationInstanceId: _context7.t2
            };
            _context7.next = 8;
            return _MessagingService["default"].getChannel(FEEDBACK_CHANNEL);

          case 8:
            channel = _context7.sent;

            _MessagingService["default"].sendMessage(channel, 'reset', message);

          case 10:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7);
  }));
  return _resetAnswers.apply(this, arguments);
}

var readFullFeedbacksAndListenAfterSuccess = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
    var feedbacks;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return _GetFullFeedbacks["default"].askForFeedbacks();

          case 3:
            feedbacks = _context.sent;
            console.log('readFullFeedbacksAndListenAfterSuccess feedbacks', feedbacks);

            if (feedbacks) {
              _FeedbackReceiveActions["default"].receiveChangesCompleted(feedbacks);
            }

            _context.next = 8;
            return _MessagingService["default"].registerChannel(FEEDBACK_CHANNEL, _FeedbackReceiveActions["default"].receiveChangesCompleted);

          case 8:
            _context.next = 14;
            break;

          case 10:
            _context.prev = 10;
            _context.t0 = _context["catch"](0);
            console.log('readFullFeedbacksAndListenAfterSuccess error', _context.t0);

            _FeedbackReceiveActions["default"].receiveChangesFailed(_context.t0);

          case 14:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 10]]);
  }));

  return function readFullFeedbacksAndListenAfterSuccess() {
    return _ref.apply(this, arguments);
  };
}();

var readFullLikesAndFeedbacksAndListenAfterSuccess = /*#__PURE__*/function () {
  var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2() {
    var feedbacks, likes;
    return _regenerator["default"].wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;
            _context2.next = 3;
            return _GetFullFeedbacks["default"].askForFeedbacks();

          case 3:
            feedbacks = _context2.sent;
            console.log('readFullLikesAndFeedbacksAndListenAfterSuccess feedbacks', feedbacks);

            if (feedbacks) {
              _FeedbackReceiveActions["default"].receiveChangesCompleted(feedbacks);
            }

            _context2.next = 8;
            return _GetFullLikes["default"].askForLikes();

          case 8:
            likes = _context2.sent;
            console.log('readFullLikesAndFeedbacksAndListenAfterSuccess likes', likes);

            if (likes) {
              _FeedbackReceiveActions["default"].receiveChangesCompleted(likes);
            }

            _context2.next = 13;
            return _MessagingService["default"].registerChannel(FEEDBACK_CHANNEL, _FeedbackReceiveActions["default"].receiveChangesCompleted);

          case 13:
            _context2.next = 19;
            break;

          case 15:
            _context2.prev = 15;
            _context2.t0 = _context2["catch"](0);
            console.log('readFullLikesAndFeedbacksAndListenAfterSuccess error', _context2.t0);

            _FeedbackReceiveActions["default"].receiveChangesFailed(_context2.t0);

          case 19:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[0, 15]]);
  }));

  return function readFullLikesAndFeedbacksAndListenAfterSuccess() {
    return _ref2.apply(this, arguments);
  };
}();

function reconnect() {
  _MessagingService["default"].unregisterChannel(FEEDBACK_CHANNEL, _FeedbackReceiveActions["default"].receiveChangesCompleted);

  innerInit();
} // cordova event


(0, _ResumeSuspendListeners.addOnSuspendListener)(function () {
  _MessagingService["default"].unregisterChannel(FEEDBACK_CHANNEL, _FeedbackReceiveActions["default"].receiveChangesCompleted);
}); // cordova event

(0, _ResumeSuspendListeners.addOnResumeListener)(function () {
  console.log('onResumeListener Feedbackservice');
  innerInit();
});